// ─── Identity Art Style Catalog ──────────────────────────────────
// Code-defined styles with admin-overlayable business knobs, mirroring
// src/config/moduleCatalog.js. Pack art is served from
// public/identity-art/{styleId}/{archetypeId}.webp (Firebase Hosting in prod).

const TIER_RANK = { free: 0, pro: 1, premium: 2, founder: 3 };

// Business knobs an admin may overlay from config/public → identityStyles.
const OVERLAYABLE_KEYS = ['access', 'requiredTier', 'coinCost', 'status'];

const STYLES = [
    {
        id: 'playing-card',
        name: 'Playing Cards',
        blurb: 'Your personas as a collectible deck.',
        frame: 'card',
        access: 'free', // launch flag: first style free for everyone (spec §6)
        requiredTier: null,
        coinCost: 0,
        status: 'available',
    },
    {
        id: 'notion-ink',
        name: 'Notion Ink',
        blurb: 'Hand-drawn black & white illustrations.',
        frame: 'plate',
        access: 'unlockable',
        requiredTier: 'pro', // included from pro up; free users buy with coins
        coinCost: 750,
        status: 'available',
    },
];

let getPublicConfig = () => null;
export function __setPublicConfigGetter(fn) { getPublicConfig = fn; }

function applyOverlay(entry) {
    const overlay = getPublicConfig()?.identityStyles?.[entry.id];
    if (!overlay) return entry;
    const merged = { ...entry };
    OVERLAYABLE_KEYS.forEach(k => {
        if (overlay[k] !== undefined) merged[k] = overlay[k];
    });
    return merged;
}

export function identityStyles() {
    return STYLES.map(applyOverlay).filter(s => s.status !== 'hidden');
}

export function getStyle(styleId) {
    const entry = STYLES.find(s => s.id === styleId);
    return entry ? applyOverlay(entry) : null;
}

export function packArtUrl(styleId, archetypeId) {
    return `/identity-art/${styleId}/${archetypeId}.webp`;
}

export function styleInventoryId(styleId) {
    return `style-${styleId}`;
}

export function isStyleUnlocked(style, { tier = 'free', inventory = [] } = {}) {
    if (!style) return false;
    if (style.access === 'free') return true;
    if (inventory.includes(styleInventoryId(style.id))) return true;
    if (style.requiredTier && TIER_RANK[tier] >= TIER_RANK[style.requiredTier]) return true;
    return false;
}

// ── Playing-card chrome: each archetype is a fixed card (e.g. K♣) ──
const RANKS = ['A', 'K', 'Q', 'J'];
const SUITS = [
    { suit: 'spades', suitChar: '♠' },
    { suit: 'hearts', suitChar: '♥' },
    { suit: 'diamonds', suitChar: '♦' },
    { suit: 'clubs', suitChar: '♣' },
];

export function cardAssignment(archetypeId) {
    let hash = 0;
    for (let i = 0; i < archetypeId.length; i++) {
        hash = (hash * 31 + archetypeId.charCodeAt(i)) >>> 0;
    }
    const { suit, suitChar } = SUITS[hash % 4];
    return { rank: RANKS[(hash >>> 2) % 4], suit, suitChar };
}
